import React, { useState, useEffect } from 'react';
import DataTable from './DataTable';
import HTTPService, { fetchProgram } from '../../../utils/axios';
import { useParams } from 'react-router-dom';

function ProgramScope() {
  const {id} = useParams();
  const {invokeApi} = HTTPService();
  const [ProgramScope, setProgramScope] = useState();
  const [programData, setProgramData] = useState([]); // Will hold a single program in an array
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);


 const fetchProgramScope = async () => {
  try {
    const response = await invokeApi({
      method: "GET",
      url: `programs/`,
      params: { id },
    });
    console.log("The Programs: ", response);
    return response.results; // return the data instead of setting it here
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

  useEffect(() => {
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const data = await fetchProgramScope(); // await here
      setProgramData(data); // this should now be an array
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  fetchData();
}, []);


  return (
    // <div className="min-h-screen bg-gray-50 py-8">
    //   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    //     <div className="text-center mb-10">
    //       <h1 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
    //         Program Details
    //       </h1>
    //       <p className="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4">
    //         Detailed information for the selected program.
    //       </p>
        // </div>
        
        <div className="mt-2">
          <DataTable 
            data={programData} 
            isLoading={isLoading} 
            error={error} 
          />
        </div>
    //   </div>
    // </div>
  );
}

export default ProgramScope;
